import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { heroSlides } from '@/mocks/movies';
import { getMovieById } from '@/utils/movies';

export default function HeroCarousel() {
  const [active, setActive] = useState(0);
  const total = heroSlides.length;

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActive((prev) => (prev + 1) % total);
    }, 6000);
    return () => window.clearInterval(timer);
  }, [total]);

  return (
    <section className="relative w-full h-[560px] md:h-[640px] lg:h-[720px] overflow-hidden">
      {heroSlides.map((slide, index) => {
        const movie = getMovieById(slide.id);
        if (!movie) return null;
        const Heading = index === 0 ? 'h1' : 'h2';
        return (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === active ? 'opacity-100' : 'opacity-0 pointer-events-none'
            }`}
            aria-hidden={index !== active}
          >
            <img
              src={slide.image}
              alt={`${movie.title} 焦点剧照`}
              title={`${movie.title} - 高清影视推荐`}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/85 to-background-50/20"></div>
            <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-background-50/50"></div>

            <div className="relative h-full w-full px-4 md:px-8 flex items-center">
              <div className={`max-w-2xl ${index === active ? 'animate-fade-up' : ''}`}>
                <span className="inline-flex items-center gap-2 text-xs font-medium text-primary-300 bg-primary-950/70 border border-primary-800/60 px-3 py-1 rounded-full">
                  <i className="ri-fire-fill"></i>
                  {slide.tagline}
                </span>
                <Heading className="mt-4 font-heading font-extrabold text-foreground-50 text-3xl md:text-5xl lg:text-6xl leading-tight">
                  {movie.title}
                </Heading>
                <p className="mt-2 text-foreground-400 text-sm md:text-base">{movie.subtitle}</p>
                <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-foreground-300">
                  <span className="flex items-center gap-1 text-primary-400 font-semibold">
                    <i className="ri-star-fill"></i>
                    {movie.rating.toFixed(1)}
                  </span>
                  <span>{movie.year}</span>
                  <span>{movie.region}</span>
                  <span>{movie.duration}</span>
                  <span className="text-foreground-400 hidden sm:inline">{movie.genres.join(' / ')}</span>
                </div>
                <p className="mt-4 text-foreground-300 text-sm leading-relaxed max-w-xl line-clamp-2 hidden sm:block">
                  {movie.summary}
                </p>
                <div className="mt-6 flex flex-wrap items-center gap-3">
                  <Link
                    to={`/detail/${movie.id}`}
                    className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-play-fill text-lg"></i>
                    立即观看
                  </Link>
                  <Link
                    to={`/detail/${movie.id}`}
                    className="inline-flex items-center gap-2 h-11 px-6 rounded-md border border-foreground-600 text-foreground-100 text-sm font-semibold hover:bg-background-200/70 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-information-line text-lg"></i>
                    作品详情
                  </Link>
                </div>
              </div>
            </div>
          </div>
        );
      })}

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2 z-10">
        {heroSlides.map((slide, index) => (
          <button
            key={slide.id}
            type="button"
            onClick={() => setActive(index)}
            aria-label={`切换到第 ${index + 1} 张推荐`}
            className={`h-2 rounded-full transition-all cursor-pointer ${
              index === active ? 'w-8 bg-primary-500' : 'w-2 bg-foreground-600 hover:bg-foreground-400'
            }`}
          ></button>
        ))}
      </div>
    </section>
  );
}